import React, { Component } from 'react';
import ReactDOM from 'react-dom'
import articles from './Articles';


class Information extends Component {
  constructor(props) {
    super(props);
    this.state = {
      contentsInViewPort: true,
    };
    this.nodes = new Map();

    this.handleScroll = this.handleScroll.bind(this);
  }

  handleShow(article) {
    const node = this.nodes.get(article);
    if (node) {
      ReactDOM.findDOMNode(node).scrollIntoView({ block: 'start', behavior: 'smooth' });
    }
  };

  handleScroll() {
    const pageY = window.pageYOffset || document.documentElement.scrollTop;
    const innerHeight = document.documentElement.clientHeight;

    if (pageY > innerHeight && this.state.contentsInViewPort === true) {
      this.setState({contentsInViewPort: false});
    }

    if (pageY < innerHeight && this.state.contentsInViewPort === false) {
      this.setState({contentsInViewPort: true});
    }
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  get contents() {
    return (
      <div>
        <h4
          ref={(element) => this.nodes.set('Сведения об автошколе', element)}
          className="important"
        >
          Сведения об автошколе
        </h4>
        <ul className="list_no-style">
          { articles.map((article, i) => {
            return <li
              key={i}
            >
              <a
                className="link"
                onClick={this.handleShow.bind(this, article.name)}>
                {article.name}
              </a>
            </li>
          })}
          </ul>
      </div>)
  }

  get articles() {
    return articles.map((article, i) => {
      return (
        <div
          key={i}
          ref={(element) => this.nodes.set(article.name, element)}
        >
          <h4 className="important">{article.name}</h4>
          {article.component}
          </div>
      )
    })

  }

  get upButton() {
    if (!this.state.contentsInViewPort) {
      return <button
        onClick={this.handleShow.bind(this, 'Сведения об автошколе')}
        className="upButton hide-for-small-only hide-for-medium-only">
        Сведения об автошколе
      </button>
    }
  }

  render() {
    return (
      <div className="row information align-center">
        <div className="columns small-12 medium-12 large-8">
          {this.contents}
          {this.articles}
          {this.upButton}
        </div>
      </div>
    );
  }
}

export default Information;






// WEBPACK FOOTER //
// ./src/components/Information/Information.jsx